import 'velocity-animate';

var $mediaItem = $('.js-media-item'),
    $mediaItemImage = $('.js-media-item img'),
    $mediaItemVideo = $('.js-media-item .js-media-iframe'),
    $mediaItemWrapper = $('.js-media-wrapper'),
    $mediaThumbnail = $('.js-media-thumbnail'),
    $mediaLeftArrow = $('.js-media-previous'),
    $mediaRightArrow = $('.js-media-next'),
    currentMediaItemIndex = 0;

function init() {
    // Check if carousel is enabled
    if($mediaThumbnail[0]){

        // Bind click event to mediaThumbnails
        bindThumbnailClickEvents();

        // Bind navigation click events
        bindNavigationClickEvents();

    };
}

function bindThumbnailClickEvents(){
    $mediaThumbnail.on('click', function(e){
        e.preventDefault();

        // Navigate to clicked media item
        navigateToMediaItem(this);
    });
}

function bindNavigationClickEvents(){
    $mediaLeftArrow.on('click', function(){

        if(currentMediaItemIndex > 0){
            // Update currentMediaItemIndex
            currentMediaItemIndex -= 1;

            // Get previous media item
            var mediaItem = $mediaThumbnail[currentMediaItemIndex];

            // Navigate to clicked media item
            navigateToMediaItem(mediaItem);
        }

    });

    $mediaRightArrow.on('click', function(){

        if(($mediaThumbnail.length-1) > currentMediaItemIndex){
            // Update currentMediaItemIndex
            currentMediaItemIndex += 1;

            // Get next media item
            var mediaItem = $mediaThumbnail[currentMediaItemIndex];

            // Navigate to clicked media item
            navigateToMediaItem(mediaItem);
        }

    });
}

function navigateToMediaItem(mediaThumbnailElement){

    // Get thumbnail image
    var imagePath = getImagePath(mediaThumbnailElement);

    // Set image to js-media-item
    setMediaItem(imagePath);

    // Set thumbnail to active
    setThumbnailToActive(mediaThumbnailElement);

    // Set index of current media item
    setCurrentMediaItemIndex(mediaThumbnailElement);

    // Remove all hidden classes
    $mediaLeftArrow.removeClass('u-hidden');
    $mediaRightArrow.removeClass('u-hidden');

    // If first item, hide arrow left
    if(currentMediaItemIndex == 0) {
        $mediaLeftArrow.addClass('u-hidden');
    }

    // If last item, hide arrow right
    if(currentMediaItemIndex == $mediaThumbnail.length-1) {
        $mediaRightArrow.addClass('u-hidden');
    }
}

function setCurrentMediaItemIndex(mediaThumbnailElement){
    currentMediaItemIndex = $(mediaThumbnailElement).data('thumbnail');
}

function getImagePath(mediaThumbnailElement){
    return $(mediaThumbnailElement).find('img').attr('src');
}

function setMediaItem(imagePath){

    $mediaItemWrapper.addClass('animating');

    // Fade out
    $mediaItem
        .velocity('fadeOut', {
            duration: 200,
            display: 'inline',
            complete: function(elements) {

                // Replace source attribute
                $mediaItemImage.attr('src', imagePath);
                $mediaItemImage.show();
                $mediaItemVideo.hide();

                // Fade in
                $mediaItem.velocity('fadeIn', {
                    duration:200,
                    complete: function(){
                        // Remove class
                        $mediaItemWrapper.removeClass('animating');
                    }
                });

            }
        });
}

function setThumbnailToActive(mediaThumbnailElement){
    // Remove active classes
    $mediaThumbnail.removeClass('active');

    // Set active class to selected mediaThumbnail element
    $(mediaThumbnailElement).addClass('active');
}

$(init);
